import React from 'react';
import styled from 'styled-components';
import gql from 'graphql-tag';
import moment from 'moment'
import { useQuery } from '@apollo/react-hooks';
import { NavLink } from 'react-router-dom';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import CircularProgress from '@material-ui/core/CircularProgress';
import useExpirationColor from 'helpers/useExpirationColor';
import Block from 'components/common/block';
import Pagination from 'components/common/pagination';
import { ReactComponent as HoseBunIcon } from 'assets/vectors/hoseBunIcon.svg';

const HoseBunsQuery = gql`
  query HoseBuns ($first: Int, $after: String, $last: Int, $before: String, $sortBy: [String], $expiresIn: Int){
    hoseBuns(first: $first, after: $after, last: $last, before: $before, sortBy: $sortBy, expiresIn: $expiresIn) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
        startCursor
      }
      edges {
        node {
          id
          plNumber
          expireDate
          serialNumber
        }
      }
    }
  }
`;

const resultCount = 5;

function HoseBuns() {
  const [paginationVariables, setPaginationVariables] = React.useState({ first: resultCount });
  const {textColor} = useExpirationColor();
  const { data, loading } = useQuery(HoseBunsQuery, {
    variables: {
      expiresIn: 31,
      sortBy: ['expireDate asc'],
      ...paginationVariables,
    },
    fetchPolicy: 'network-only',
  });

  const hoseBuns = data ? data.hoseBuns.edges.map(u => u.node) : [];
  const pageInfo = data ? data.hoseBuns.pageInfo : {};

  return (
    <StyledBlock title={<BlockTitle><HoseBunIcon style={{ marginRight: '8px'}} /> EXPIRING HOSE BUNS</BlockTitle>}>
      {
        loading
          ? <CircularProgress size={64} style={{ margin: '64px auto', display: 'block' }} />
          : <TableContainer>
              <Table aria-label="simple table" style={{ whiteSpace: 'nowrap' }}>
                <TableHead>
                  <TableRow>
                    <TableCell>
                      PL Nr.
                    </TableCell>
                    <TableCell>
                      Serial Nr.
                    </TableCell>
                    <TableCell>
                      Expire date
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {
                    hoseBuns.length
                      ? hoseBuns.map((hoseBun) => (
                          <TableRow key={hoseBun.id}>
                            <TableCell>
                              <Link to={`/dashboard/equipment/hoseBuns/${hoseBun.id}`}>{hoseBun.plNumber}</Link>
                            </TableCell>
                            <TableCell>
                              {hoseBun.serialNumber}
                            </TableCell>
                            <TableCell style={{color: textColor(hoseBun.expireDate)}}>
                              {hoseBun.expireDate ? moment(hoseBun.expireDate, 'YYYY-MM-DD').format('DD/MM/YYYY') : null}
                            </TableCell>
                          </TableRow>
                        ))
                      : <TableRow>
                          <TableCell>No expiring hose buns</TableCell>
                          <TableCell />
                          <TableCell />
                        </TableRow>
                  }
                </TableBody>
              </Table>
            </TableContainer>
      }
      <Pagination
        paginationVariables={paginationVariables}
        setPaginationVariables={setPaginationVariables}
        resultCount={resultCount}
        pageInfo={pageInfo}
        style={{
          paddingTop: '16px',
          marginTop: 'auto',
        }}
      />
    </StyledBlock>
  );
}

const BlockTitle = styled.div`
  display: flex;
  align-items: center;
  color: ${props => props.theme.colors.primaryColor};
`;

const StyledBlock = styled(Block)`
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const Link = styled(NavLink)`
  color: ${props => props.theme.colors.primaryColor};
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

export default HoseBuns;
